<template>
  <v-sheet>
<!--    {{sortedSentenceData}}-->
    <v-row class="flex-row justify-center">
      <v-col cols="12" xl="2" lg="2" xs="2" sm="2" >
          <v-select
              v-model="selectedLevel"
              :items="['pmid-level', 'sentence-level']"
              dense
              outlined
          ></v-select>

      </v-col>
      <v-col>
        <v-btn dense color="primary" small @click="downloadCSV" style="text-transform: none" class="my-2" >
          Download TSV <v-icon>mdi-download-box-outline</v-icon>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" xl="3" lg="3" xs="3" sm="3">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            outlined
            dense
            clearable
            single-line
            hide-details
            class="my-2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-sheet outlined v-if="selectedLevel === 'pmid-level'">
<!--      {{localTdata}}-->
      <v-data-table
          :headers="headers"
          :items="localTdata"
          :search="search"
          item-key="uniqueKey"
          :items-per-page="10"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100],
                          'show-current-page': true}"
          dense
          fixed-header
          no-results-text="No results found for the current search terms. Please try different keywords."
          no-data-text="No results available. Please try other site."
          show-expand
          class="elevation-1"
      >
        <template v-slot:item.index="{ index }">
          <span>{{ index + 1 }}</span>
        </template>
        <template v-slot:item.sort_id="{ item }">
          <a v-if="item.PMC"
             :href="`https://www.ncbi.nlm.nih.gov/pmc/articles/${formatPmcId(item.PMC)}/`"
             target="_blank">
            {{ formatPmcId(item.PMC) }}
          </a>
          <a v-else-if="item.PMID && item.PMID > 0"
             :href="`https://pubmed.ncbi.nlm.nih.gov/${Math.floor(item.PMID)}`"
             target="_blank">
            {{ Math.floor(item.PMID) }}
          </a>
          <span v-else>-</span>
        </template>
<!--        <template v-slot:item.PMID="{ item }">-->
<!--          <a v-if="item.PMID && item.PMID > 0"-->
<!--             :href="`https://pubmed.ncbi.nlm.nih.gov/${Math.floor(item.PMID)}`"-->
<!--             target="_blank">-->
<!--            {{ Math.floor(item.PMID) }}-->
<!--          </a>-->
<!--          <a v-else-if="item.PMC"-->
<!--             :href="`https://www.ncbi.nlm.nih.gov/pmc/articles/${item.PMC}/`"-->
<!--             target="_blank">-->
<!--            {{ item.PMC }}-->
<!--          </a>-->
<!--          <span v-else>-</span>-->
<!--        </template>-->
        <template v-slot:item.evidence_count="{ item }">
          <span>{{ item.detail.length }}</span> <!-- Display the number of elements in detail -->
        </template>
        <template v-slot:item.abstract="{ item }">
          <div class="my-1">
            <div :class="{ 'clamped-text': !item.isExpanded }">
              {{ item.abstract && item.abstract.trim() !== '' ? item.abstract : '-' }}
            </div>

            <v-btn
                v-if="item.abstract && item.abstract.trim() !== ''"
                x-small
                color="black"
                rounded
                text
                outlined
                style="text-transform: none"
                @click.stop="toggleExpand(item)"
            >
              {{ item.isExpanded ? 'less' : 'more' }}
            </v-btn>
          </div>
        </template>

        <!--        <template v-slot:item.abstract="{ item }" >-->
<!--          <div class="my-1">-->
<!--            <div v-if="!item.isExpanded" class="clamped-text">-->
<!--              {{ item.abstract }}-->
<!--            </div>-->
<!--            <div v-else>-->
<!--              {{ item.abstract }}-->
<!--            </div>-->
<!--            <v-btn x-small color="black" rounded text @click="toggleExpand(item)" outlined style="text-transform: none">-->
<!--              {{ item.isExpanded ? 'less' : 'more' }}-->
<!--            </v-btn>-->
<!--          </div>-->
<!--        </template>-->
        <template v-slot:expanded-item="{ headers,item }">
          <td :colspan="headers.length">
            <v-sheet outlined class="ma-1">
              <v-data-table
                  :headers="subheader"
                  :items="item.detail"
                  :search="search"
                  class="sentence-table"
                  item-key="uniqueKey"
                  :items-per-page="10"
                  :footer-props="{ 'items-per-page-options': [10, 20, 50, 100],
                          'show-current-page': true}"
                  dense

              >
                <template v-slot:item.index="{ index }">
                  <span>{{ index + 1 }}</span>
                </template>
                <template v-slot:item.section="{}">
                  <div>Abstract</div>
                </template>
<!--                <template v-slot:item.original_substrate="{ item, index }">-->
<!--                  <span style="color: #f2711c">{{ item.original_substrate }}</span>-->
<!--                </template>-->

<!--                <template v-slot:item.original_site="{ item, index }">-->
<!--                  <span style="color: #21ba45!important;">{{ item.original_site }}</span>-->
<!--                </template>-->

<!--                <template v-slot:item.sentence="{ item }">-->
<!--                  <div v-html="h_sentenceFormatter(item.sentence, item)" style="white-space: normal; overflow: visible; word-break: break-word;"></div>-->
<!--                </template>-->
                <template v-slot:item.sentence="{ item }">
                  <div
                      v-html="h_sentenceFormatter(item.sentence, item)"
                      class="sentence-cell"

                  ></div>
                </template>

                <template v-slot:item.cancerhallmark="{ item, index }">
                  <span >{{ item.cancerhallmark }}</span>
                </template>
<!--                <template v-slot:item.link="{ item }">-->
<!--                 <a :href="pmidToPmcLinkFormatter(item.PMC, item.sentence)" target="_blank"><v-icon small>mdi-share</v-icon></a>-->
<!--                </template>-->
                <template v-slot:item.link="{ item }">
                  <a v-if="item.PMC || item.PMID" :href="getLinkUrl(item)" target="_blank">
                    <v-icon small>mdi-share</v-icon>
                  </a>
                  <span v-else>-</span>
                </template>

                <template v-slot:item.chemical="{ item }">
                  <span>{{ item.chemical && item.chemical.length > 0 ? item.chemical : '-' }}</span>
                </template>
                <template v-slot:item.gene="{ item }">
                  <span>{{ item.gene && item.gene.length > 0 ? item.gene : '-' }}</span>
                </template>

                <template v-slot:item.disease="{ item }">
                  <span>{{ item.disease && item.disease.length > 0 ? item.disease : '-' }}</span>
                </template>

                <template v-slot:item.cellline="{ item }">
                  <span>{{ item.cellline && item.cellline.length > 0 ? item.cellline : '-' }}</span>
                </template>


              </v-data-table>
            </v-sheet>

          </td>
        </template>
      </v-data-table>
    </v-sheet>
    <v-sheet outlined v-if="selectedLevel === 'sentence-level'">
<!--      {{tdata}}-->
      <v-data-table
          :headers="headers1"
          :items="sortedSentenceData"
          :search="search"
          item-key="uniqueKey"
          dense
          fixed-header
          height="520px"
          :items-per-page="10"
          class="sentence-table"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100],
                          'show-current-page': true}"
          no-results-text="No results found for the current search terms. Please try different keywords."
          no-data-text="No results available. Please try other site."
      >
        <template v-slot:item.id="{ item }">
          {{item.substrate}}:{{item.harm_site}}
        </template>
        <template v-slot:item.sort_id="{ item }">
          <a v-if="item.PMC"
             :href="`https://www.ncbi.nlm.nih.gov/pmc/articles/${formatPmcId(item.PMC)}/`"
             target="_blank">
            {{ formatPmcId(item.PMC) }}
          </a>
          <a v-else-if="item.PMID && item.PMID > 0"
             :href="`https://pubmed.ncbi.nlm.nih.gov/${Math.floor(item.PMID)}`"
             target="_blank">
            {{ Math.floor(item.PMID) }}
          </a>
          <span v-else>-</span>
        </template>
<!--        <template v-slot:item.PMID="{ item }">-->
<!--          <a v-if="item.PMID && item.PMID > 0"-->
<!--             :href="`https://pubmed.ncbi.nlm.nih.gov/${Math.floor(item.PMID)}`"-->
<!--             target="_blank">-->
<!--            {{ Math.floor(item.PMID) }}-->
<!--          </a>-->
<!--          <a v-else-if="item.PMC"-->
<!--             :href="`https://www.ncbi.nlm.nih.gov/pmc/articles/${item.PMC}/`"-->
<!--             target="_blank">-->
<!--            {{ item.PMC }}-->
<!--          </a>-->
<!--          <span v-else>-</span>-->
<!--        </template>-->
<!--        <template v-slot:item.PMID="{ item }">-->
<!--          <a :href="`https://pubmed.ncbi.nlm.nih.gov/${Math.floor(item.PMID)}`" target="_blank">-->
<!--            {{ Math.floor(item.PMID) }}-->
<!--          </a>-->
<!--        </template>-->
<!--        <template v-slot:item.PMID="{ item, index }">-->
<!--          <a :href="`https://pubmed.ncbi.nlm.nih.gov/${item.PMID}`" target="_blank">{{ item.PMID }}</a>-->
<!--        </template>-->

        <template v-slot:item.sentence="{ item }">
            <div v-html="h_sentenceFormatter(item.sentence, item)" class="sentence-cell" style="white-space: normal; overflow: visible; word-break: break-word;"></div>
        </template>
<!--        <template v-slot:item.link="{ item }">-->
<!--          <a :href="pmidToPmcLinkFormatter(item.PMC, item.sentence)" target="_blank"><v-icon small>mdi-share</v-icon></a>-->
<!--        </template>-->
        <template v-slot:item.link="{ item }">
          <a v-if="item.PMC || item.PMID" :href="getLinkUrl(item)" target="_blank">
            <v-icon small>mdi-share</v-icon>
          </a>
          <span v-else>-</span>
        </template>

        <template v-slot:item.chemical="{ item }">
          <span>{{ item.chemical && item.chemical.length > 0 ? item.chemical : '-' }}</span>
        </template>

        <template v-slot:item.disease="{ item }">
          <span>{{ item.disease && item.disease.length > 0 ? item.disease : '-' }}</span>
        </template>
        <template v-slot:item.gene="{ item }">
          <span>{{ item.gene && item.gene.length > 0 ? item.gene : '-' }}</span>
        </template>

        <template v-slot:item.cellline="{ item }">
          <span>{{ item.cellline && item.cellline.length > 0 ? item.cellline : '-' }}</span>
        </template>





      </v-data-table>
    </v-sheet>
  </v-sheet>
</template>

<script>

import {apiprefix} from "@/main";

export default {
  name: "DetailTextTable",
  props: ["tdata"],
  data() {
    return {
      selectedLevel:"sentence-level",
      search: '',
      localTdata: [],
      headers1:[
        // {text: 'Normalized ID', value: 'id', align: 'start', sortable: false},        // {text: 'Normalized ID', value: 'id', align: 'start', sortable: false},
        {text: 'PMC/PMID', value: 'sort_id', align: 'start',width: '7%'},
        {text: 'Sentence', value: 'sentence',width:"30%"},
        {text: 'Hallmark Process', value: 'cancerhallmark',width: '10%'},
        {text: 'Co-Disease', value: 'disease',width: '10%'},
        {text: 'Co-Gene', value: 'gene',width: '10%'},
        {text: 'Co-Chemical', value: 'chemical',width: '10%'},
        {text: 'Co-Cellline', value: 'cellline',width: '10%'},
        {text: 'Passage type', value: 'passage_type', align: 'start',width: '8%'},
        {text: 'Link', value: 'link',width: '5%',sortable:false}
      ],
      headers: [
        { text: '#', value: 'index', align: 'start', sortable: false },
        {text: 'PMC/PMID', value: 'sort_id', align: 'start'},
        { text: '#Sentences', value: 'evidence_count',sortable: false },
        {text: 'Title', value: 'title',width:"30%"},
        {text: 'Abstract', value: 'abstract'},
      ],
      subheader: [
        { text: '#', value: 'index', align: 'start', sortable: false ,width: '2%'},
        { text: 'Passage type', value: 'passage_type', align: 'start' ,width: '8%'},
        // {text: 'Original substrate', value: 'original_substrate', align: 'start'},
        // {text: 'Original site', value: 'original_site'},
        {text: 'Sentence', value: 'sentence',width: '30%'},
        {text: 'Hallmark Process', value: 'cancerhallmark',width: '10%'},
        {text: 'Co-Disease', value: 'disease',width: '10%'},
        {text: 'Co-Gene', value: 'gene',width: '10%'},
        {text: 'Co-Chemical', value: 'chemical',width: '15%'},
        {text: 'Co-Cellline', value: 'cellline',width: '10%'},
        {text: 'Link', value: 'link',width: '5%',sortable:false}
      ]
    }
  },
  methods: {
    toggleExpand(item) {
      item.isExpanded = !item.isExpanded;
    },
    transformData(data) {
      const mergedDataMap = new Map();

      data.forEach(item => {
        const key = `${item.PMID}`;
        if (mergedDataMap.has(key)) {
          mergedDataMap.get(key).detail.push({
            PMC: item.PMC,
            original_site: item.original_site,
            original_substrate: item.original_substrate,
            cancerhallmark: item.cancerhallmark,
            chemical: item.chemical,
            cellline: item.cellline,
            disease: item.disease,
            gene:item.gene,
            chemical_index: item.chemical_index,
            cellline_index: item.cellline_index,
            gene_index:item.gene_index,
            disease_index: item.disease_index,
            passage_type: item.passage_type,
            sentence: item.sentence,
          });
        } else {
          mergedDataMap.set(key, {
            PMID: item.PMID,
            PMC:item.PMC,
            substrate: item.substrate,
            site: item.harm_site,
            abstract: item.abstract,
            title: item.title,
            ptm_type: item.ptm_type,
            isExpanded: false,
            detail: [{
              PMID: item.PMID,
              PMC: item.PMC,
              original_site: item.original_site,
              original_substrate: item.original_substrate,
              cancerhallmark: item.cancerhallmark,
              chemical: item.chemical,
              cellline: item.cellline,
              gene:item.gene,
              disease: item.disease,
              chemical_index: item.chemical_index,
              cellline_index: item.cellline_index,
              gene_index:item.gene_index,
              disease_index: item.disease_index,
              passage_type: item.passage_type,
              sentence: item.sentence,
            }]
          });
        }
      });

      return Array.from(mergedDataMap.values());
    },
    getLinkUrl(item) {
      if (item.PMC) {
        return this.pmidToPmcLinkFormatter(item.PMC, this.restoreMojibake(item.sentence));
      } else if (item.PMID) {
        return this.pmidLinkFormatter(item.PMID, this.restoreMojibake(item.sentence));
      } else {
        return '#';
      }
    },
    pmidToPmcLinkFormatter( pmc, sentenceText) {
      sentenceText = this.restoreMojibake(sentenceText || "");
      const words = sentenceText.split(" ");
      const first4 = words.slice(0, 4);
      const last4 = words.slice(-4);
      const start = encodeURIComponent(first4.join(" ")).replaceAll("-", "%2D");
      const end = encodeURIComponent(last4.join(" ")).replaceAll("-", "%2D");

      const url = `https://www.ncbi.nlm.nih.gov/pmc/articles/${this.formatPmcId(pmc)}/#:~:text=${start},${end}`;
      return url
    },
    pmidLinkFormatter( pmid, sentenceText) {
      sentenceText = this.restoreMojibake(sentenceText || "");
      const words = sentenceText.split(" ");
      const first4 = words.slice(0, 4);
      const last4 = words.slice(-4);
      const start = encodeURIComponent(first4.join(" ")).replaceAll("-", "%2D");
      const end = encodeURIComponent(last4.join(" ")).replaceAll("-", "%2D");

      const url = `https://pubmed.ncbi.nlm.nih.gov/${pmid}/#:~:text=${start},${end}`;
      return url
    },

    pmidFormatter(v, sentenceText) {
      sentenceText = this.restoreMojibake(sentenceText || "");
      const words = sentenceText.split(" ");
      const first4 = words.slice(0, 4);
      const last4 = words.slice(-4);
      const start = encodeURIComponent(first4.join(" ")).replaceAll("-", "%2D");
      const end = encodeURIComponent(last4.join(" ")).replaceAll("-", "%2D");

      return `<a target="_blank" href="https://pmc.ncbi.nlm.nih.gov/articles/${this.formatPmcId(v)}/#:~:text=${start},${end}">${this.formatPmcId(v)}</a>`;
    },
    is_obj_eq(a, b) {
      for (let p in a) {
        if (a[p] != b[p]) {
          return false
        }
      }
      for (let p in b) {
        if (typeof (a[p]) === "undefined") {
          return false
        }
      }
      return true
    },
    h_sentenceFormatter(v, row) {
      const text = this.restoreMojibake(v || "");
      const styles = [];
      const debugInternalId = "MTOR_S2448_ENSP00000354558";
      const debugSentence = "Moreover, Mith also inhibited the phosphorylation of mTOR on serine 2448 and Mcl-1, and increased tBid protein in prostate tumors in athymic nude mice bearing DU145 cells as xenografts.";
      const rowInternalId = row.internal_id || row.id;

      if (rowInternalId === debugInternalId && text === debugSentence) {
        console.log("[DetailTextTable debug index]", {
          internal_id: rowInternalId,
          sentence: text,
          chemical: row.chemical,
          chemical_index: row.chemical_index,
          chemical_ranges: this.describeIndexRanges(row.chemical_index, text),
          gene: row.gene,
          gene_index: row.gene_index,
          gene_ranges: this.describeIndexRanges(row.gene_index, text),
          disease: row.disease,
          disease_index: row.disease_index,
          disease_ranges: this.describeIndexRanges(row.disease_index, text),
          cellline: row.cellline,
          cellline_index: row.cellline_index,
          cellline_ranges: this.describeIndexRanges(row.cellline_index, text)
        });
      }

      // substrate highlight
      if (row.original_substrate) {
        const sub = this.restoreMojibake(row.original_substrate);
        const index = text.indexOf(sub);
        if (index !== -1) {
          styles.push({
            start: index,
            end: index + sub.length,
            className: "highlight-substrate"
          });
        }
      }

      // site highlight
      if (row.original_site) {
        const site = this.restoreMojibake(row.original_site).trim();
        const index = text.indexOf(site);
        if (index !== -1) {
          styles.push({
            start: index,
            end: index + site.length,
            className: "highlight-site"
          });
        }
      }

      // new: highlight by index ranges
      this.addHighlightFromIndex(row.chemical_index, styles, "highlight-chemical");
      this.addHighlightFromIndex(row.cellline_index, styles, "highlight-cellline");
      this.addHighlightFromIndex(row.disease_index, styles, "highlight-disease");
      this.addHighlightFromIndex(row.gene_index, styles, "highlight-gene");

      return this.highlightRange(text, styles);
    },
    pmcToNumber(pmc) {
      if (!pmc) return Number.MAX_SAFE_INTEGER;

      return Number(String(pmc).replace(/^PMC/i, ''));
    },
    publicationSortId(item) {
      if (item.PMC) return this.pmcToNumber(item.PMC);
      if (item.PMID && item.PMID > 0) return Number(item.PMID);
      return Number.MAX_SAFE_INTEGER;
    },

    addHighlightFromIndex(indexStr, styles, className) {
      if (!indexStr) return;

      const ranges = indexStr
          .split(";")
          .map(r => r.trim())
          .filter(Boolean)
          .map(r => {
            r = this.normalizeIndexRangePart(r);
            const [s, e] = r.split("-").map(Number);
            return (!isNaN(s) && !isNaN(e)) ? { start: s, end: e } : null;
          })
          .filter(Boolean);

      const longestByStart = new Map();

      for (const range of ranges) {
        if (!longestByStart.has(range.start)) {
          longestByStart.set(range.start, range);
        } else {
          const existing = longestByStart.get(range.start);
          if (range.end > existing.end) {
            longestByStart.set(range.start, range);
          }
        }
      }

      for (const range of longestByStart.values()) {
        styles.push({
          start: range.start,
          end: range.end,
          className
        });
      }
    },
    describeIndexRanges(indexStr, text) {
      if (!indexStr) return [];

      return String(indexStr)
          .split(";")
          .map(r => r.trim())
          .filter(Boolean)
          .map(raw => {
            const normalized = this.normalizeIndexRangePart(raw);
            const [start, end] = normalized.split("-").map(Number);
            return {
              raw,
              normalized,
              start,
              end,
              text: (!isNaN(start) && !isNaN(end)) ? text.slice(start, end) : ""
            };
          });
    },
    normalizeIndexRangePart(part) {
      const value = String(part || "").trim();
      if (/^\d+-\d+$/.test(value)) return value;

      const excelDate = value.match(/^(\d{1,2})-([A-Za-z]{3})$/);
      if (!excelDate) return value;

      const monthMap = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        oct: 10,
        nov: 11,
        dec: 12
      };
      const day = Number(excelDate[1]);
      const month = monthMap[excelDate[2].toLowerCase()];
      if (!month) return value;

      const start = Math.min(day, month);
      const end = Math.max(day, month);
      return start !== end ? `${start}-${end}` : value;
    },

    highlightRange(text, ranges) {
      if (!text || !ranges || ranges.length === 0) return this.escapeHtml(text);

      ranges.sort((a, b) => a.start - b.start);

      let result = '';
      let lastIndex = 0;

      for (const range of ranges) {
        result += this.escapeHtml(text.slice(lastIndex, range.start));
        result += `<span class="${range.className}">`;
        result += this.escapeHtml(text.slice(range.start, range.end));
        result += '</span>';
        lastIndex = range.end;
      }

      result += this.escapeHtml(text.slice(lastIndex));
      return result;
    },
    restoreMojibake(value) {
      if (value === null || value === undefined) return "";

      const text = String(value);
      const mojibakePattern = /(?:Ã.|Â.|Î.|Ï.|Ð.|Ñ.|â[\u0080-\uFFFF]?)/;
      if (!mojibakePattern.test(text) || typeof TextDecoder === "undefined") {
        return text;
      }

      const win1252ReverseMap = {
        0x20ac: 0x80,
        0x201a: 0x82,
        0x0192: 0x83,
        0x201e: 0x84,
        0x2026: 0x85,
        0x2020: 0x86,
        0x2021: 0x87,
        0x02c6: 0x88,
        0x2030: 0x89,
        0x0160: 0x8a,
        0x2039: 0x8b,
        0x0152: 0x8c,
        0x017d: 0x8e,
        0x2018: 0x91,
        0x2019: 0x92,
        0x201c: 0x93,
        0x201d: 0x94,
        0x2022: 0x95,
        0x2013: 0x96,
        0x2014: 0x97,
        0x02dc: 0x98,
        0x2122: 0x99,
        0x0161: 0x9a,
        0x203a: 0x9b,
        0x0153: 0x9c,
        0x017e: 0x9e,
        0x0178: 0x9f
      };

      const bytes = [];
      for (const char of text) {
        const code = char.codePointAt(0);
        if (code <= 0xff) {
          bytes.push(code);
        } else if (Object.prototype.hasOwnProperty.call(win1252ReverseMap, code)) {
          bytes.push(win1252ReverseMap[code]);
        } else {
          return text;
        }
      }

      try {
        const decoded = new TextDecoder("utf-8", { fatal: true }).decode(new Uint8Array(bytes));
        return mojibakePattern.test(decoded) ? text : decoded;
      } catch (e) {
        return text;
      }
    },
    escapeHtml(str) {
      return String(str || '').replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
    },

    downloadCSV() {
      const csvContent = this.convertToCSV(this.sortedSentenceData);
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'ptmatlas_textmining_sentence_table.tsv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // Method to convert data to CSV format
    formatPmcId(pmc) {
      const value = String(pmc || '').trim();
      if (!value) return '';
      return value.toUpperCase().startsWith('PMC') ? value : `PMC${value}`;
    },
    formatPublicationIdForTSV(item) {
      if (item.PMC) {
        return this.formatPmcId(item.PMC);
      }

      if (item.PMID && item.PMID > 0) {
        return Math.floor(Number(item.PMID));
      }

      return '';
    },
    convertToCSV(data) {
      const customHeaders = [
        // { text: 'Normalized ID', value: 'id' },

        ...this.headers1,
      ];

      const headers = customHeaders.map(header => header.text).join('\t') + '\n';

      const rows = data.map(item => {
        return customHeaders.map(header => {
          if (header.value === 'id') {
            return `${item.substrate}:${item.harm_site}`;
          } else if (header.value === 'sort_id') {
            return this.formatPublicationIdForTSV(item);
          } else {
            return item[header.value] !== undefined ? item[header.value] : '';
          }
        }).join('\t');
      }).join('\n');

      return headers + rows;
    }

  },
  mounted() {
  },
  computed: {
    sortedSentenceData() {
      return this.tdata
          .map((item, index) => ({
            ...item,
            uniqueKey: item.uniqueKey || `${item.PMID || item.PMC || 'NA'}_${index}`,
            sort_id: this.publicationSortId(item)
          }))
          .sort((a, b) => a.sort_id - b.sort_id);
    }
  },
  watch: {

    tdata: {
      handler(newTdata) {
        this.localTdata = this.transformData(newTdata)
            .map((item, index) => ({
              ...item,
              uniqueKey: index,
              sort_id: this.publicationSortId(item)
            }))
            .sort((a, b) => a.sort_id - b.sort_id);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.clamped-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sentence-text {
  white-space: normal;
  overflow: visible;
  word-break: break-word;
}
::v-deep .highlight-substrate {
  color: #e53935 !important;   /* red text */
  font-weight: bold;
}
::v-deep .highlight-site {
  color: #1e88e5 !important;   /* blue text */
  font-weight: bold;
}
::v-deep .highlight-chemical {
  background-color: #318e34;
  color: #fff !important;
  border-radius: 2px;
  padding: 0 2px;
}
::v-deep .highlight-cellline {
  background-color: #50b4b4;
  color: #fff !important;
  border-radius: 2px;
  padding: 0 2px;
}
::v-deep .highlight-disease {
  background-color: #f37e01;
  color: #fff !important;
  border-radius: 2px;
  padding: 0 2px;
}
::v-deep .highlight-gene {
  background-color: #8b2595;
  color: #fff !important;
  border-radius: 2px;
  padding: 0 2px;
}

.sentence-table th,
.sentence-table td {
  white-space: normal !important;
  word-break: break-word !important;
}

::v-deep .v-data-table-header th.sortable {
  color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep .v-data-table-header th.sortable .v-data-table-header__icon {
  opacity: 1 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep .v-data-table-header th.sortable span {
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 1 !important;
}

::v-deep .v-data-table-header th.sortable.active,
::v-deep .v-data-table-header th.sortable.active .v-data-table-header__icon,
::v-deep .v-data-table-header th.sortable:hover,
::v-deep .v-data-table-header th.sortable:hover .v-data-table-header__icon {
  color: #000000 !important;
  opacity: 1 !important;
}

</style>
